// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YRSZo","largestCol":"styles_largestCol__GYb69","smallestCol":"styles_smallestCol__1pgQ9"};